import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { Typography, Button, Input } from "@atoms";
import { theme } from "@theme";
import { Container } from "./recoveryPassword.styles";
import { axiosInstance } from "utils";
import { Form } from "antd";

function Recovery() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [form] = Form.useForm();
  const [isDisabled, setIsDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const user_id = searchParams.get("user_id");
  const timestamp = searchParams.get("timestamp");
  const signature = searchParams.get("signature");

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await axiosInstance.post("/accounts/recovery-password/", {
        user_id,
        timestamp,
        signature,
        password,
        password_confirm: confirm,
      });

      toast.success(t("passwordChange"));
      navigate("/login");
    } catch (error) {
      toast.error(t("somethingerr"), {
        position: "bottom-right",
        theme: "colored",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleValuesChange = async () => {
    form
      .validateFields()
      .then((res) => {
        setIsDisabled(false);
      })
      .catch((err) => {
        setIsDisabled(!!err.errorFields.length);
      });
  };

  return (
    <Container>
      <Typography as="h2">{t("recoveryPassword")}</Typography>
      <Form
        style={{ width: "100%" }}
        form={form}
        layout="vertical"
        onValuesChange={handleValuesChange}
        requiredMark={false}
      >
        <Form.Item
          label={t("password")}
          name="password"
          rules={[
            { required: true, message: t("writePassword") },
            {
              min: 8,
              message: t("passwordError"),
            },
          ]}
        >
          <Input.Password
            name="password"
            form={form}
            value={password}
            onChange={setPassword}
            placeholder={t("writePassword")}
          />
        </Form.Item>
        <Form.Item
          label={t("repeatPassword")}
          name="confirm"
          dependencies={["password"]}
          rules={[
            { required: true, message: t("repeatPassword") },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("password") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(t("passdontmatch")));
              },
            }),
          ]}
        >
          <Input.Password
            name="confirm"
            form={form}
            value={confirm}
            onChange={setConfirm}
            placeholder={t("writePassword")}
          />
        </Form.Item>
      </Form>

      <Button
        variant="primary"
        size="large"
        fullWidth
        disabled={isDisabled}
        loading={isLoading}
        onClick={handleClick}
      >
        <Typography style={{ color: theme.palette.default }}>
          {t("continue")}
        </Typography>
      </Button>
    </Container>
  );
}

Recovery.CheckRecovery = () => {
  return (
    <Container>
      <Typography as="h3">Проверьте вашу почту</Typography>
      <Typography
        style={{
          color: "rgba(6, 6, 6, 0.8)",
          textAlign: "center",
          marginTop: "-8px",
        }}
      >
        Мы отправили письмо на почту для сброса парола
      </Typography>

      <Button
        variant="primary"
        size="large"
        fullWidth
        onClick={() => (window.location.href = "mailto:")}
      >
        <Typography style={{ color: theme.palette.default }}>
          Открыть приложение почта
        </Typography>
      </Button>
      <Button
        variant="outlined"
        size="large"
        fullWidth
        onClick={() => (window.location.href = "/")}
        style={{ marginTop: "-8px" }}
      >
        <Typography style={{ color: theme.palette.primary }}>
          Вернуться на главную
        </Typography>
      </Button>
    </Container>
  );
};

export default Recovery;
